import React, { useEffect, useState } from "react";
import Grid from '@mui/material/GridLegacy';
import arrangeSquare from '../../images/arrangeSquare.png';
import { useAppContext } from "../../context";
import LeftInput from "./LeftInput";
import ChangeCourses from "./ChangeCourses";
import RightInput from "./RightInput";
import { useTheme, useMediaQuery } from "@mui/material";
import { useCurrencyCalc } from "./useCurrencyCalc";

type Props = {
    mode: "MAIN" | "POPUP";
};

export default function CalculateCourseComponent({ mode }: Props) {
    const {
        currencySellRates,
        // currencyBuyRates,
        currence,
        // currentRateData,
        // setCreateOrder,
        // createOrder,
        setBuyCurrencyInfo,
        setSellCurrencyInfo,
        setBuyCurrencyForInfo,
        // openPopUp,
        // tab
    } = useAppContext();


    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const isColumn = mode === "POPUP" || isMobile;
    const [state, setState] = useState({
        sellAmount: "",
        buyAmount: "",
        sellCurrency: "GEL",
        buyCurrency: mode !== "POPUP" ? "USD" : currence[0],
        activeSide: "SELL" as "SELL" | "BUY",
    });

    const [changeInput, setChangeInput] = useState<boolean>(false);

    const { convert } = useCurrencyCalc(useAppContext());

    useEffect(() => {

        !changeInput && setBuyCurrencyForInfo((1 / currencySellRates[`${state.buyCurrency}_GEL`]).toFixed(4));

    }, [setBuyCurrencyForInfo, state.buyCurrency, currencySellRates, changeInput]);

    const onSellChange = (value: string | number) => {
        if(RegExp('^\\d*(\\.\\d{0,4})?$').test(value.toString()) === false) {
            return;
        }
        const stringValue = value.toString();
        const buyAmount = convert({
            amount: stringValue,
            from: state.sellCurrency,
            to: state.buyCurrency,
            side: "SELL",
        });

        setState(s => ({
            ...s,
            sellAmount: stringValue,
            buyAmount,
            activeSide: "SELL",
        }));

        setChangeInput(true);
    };

    const onBuyChange = (value: string | number) => {
        if(RegExp('^\\d*(\\.\\d{0,4})?$').test(value.toString()) === false) {
            return;
        }
        const stringValue = value.toString();
        const sellAmount = convert({
            amount: stringValue,
            from: state.buyCurrency,
            to: state.sellCurrency,
            side: "BUY",
        });

        setState(s => ({
            ...s,
            buyAmount: stringValue,
            sellAmount,
            activeSide: "BUY",
        }));
        setChangeInput(true);
    };

    const handleSwitch = () => {
        setState(prev => {
            const nextSellCurrency = prev.buyCurrency;
            const nextBuyCurrency = prev.sellCurrency;

            let sellAmount = prev.sellAmount;
            let buyAmount = prev.buyAmount;

            if (prev.activeSide === "SELL") {
                buyAmount = convert({
                    amount: prev.sellAmount,
                    from: nextSellCurrency,
                    to: nextBuyCurrency,
                    side: "SELL",
                });
            } else {
                sellAmount = convert({
                    amount: prev.buyAmount,
                    from: nextBuyCurrency,
                    to: nextSellCurrency,
                    side: "BUY",
                });
            }

            return {
                ...prev,
                sellCurrency: nextSellCurrency,
                buyCurrency: nextBuyCurrency,
                sellAmount,
                buyAmount,
            };
        });
        
        
        // context info sync
        setSellCurrencyInfo(state.buyCurrency);
        setBuyCurrencyInfo(state.sellCurrency);
    };


    const onSellCurrencyChange = (newSellCurrency: string) => {
        setState(prev => {
            let buyAmount = prev.buyAmount;
            let sellAmount = prev.sellAmount;

            if (prev.activeSide === "SELL") {
                buyAmount = convert({
                    amount: prev.sellAmount,
                    from: newSellCurrency,
                    to: prev.buyCurrency,
                    side: "SELL",
                });
            } else {
                sellAmount = convert({
                    amount: prev.buyAmount,
                    from: prev.buyCurrency,
                    to: newSellCurrency,
                    side: "BUY",
                });
            }

            return {
                ...prev,
                sellCurrency: newSellCurrency,
                sellAmount,
                buyAmount,
            };
        });

        setSellCurrencyInfo(newSellCurrency);
    };


    const onBuyCurrencyChange = (newBuyCurrency: string) => {
        setState(prev => {
            let buyAmount = prev.buyAmount;
            let sellAmount = prev.sellAmount;

            if (prev.activeSide === "SELL") {
                buyAmount = convert({
                    amount: prev.sellAmount,
                    from: prev.sellCurrency,
                    to: newBuyCurrency,
                    side: "SELL",
                });
            } else {
                sellAmount = convert({
                    amount: prev.buyAmount,
                    from: newBuyCurrency,
                    to: prev.sellCurrency,
                    side: "BUY",
                });
            }

            return {
                ...prev,
                buyCurrency: newBuyCurrency,
                sellAmount,
                buyAmount,
            };
        });

        setBuyCurrencyInfo(newBuyCurrency);
    };


    return (
        <Grid container spacing={2} direction={isColumn ? "column" : "row"} alignItems="center" justifyContent="center">
            <LeftInput
                amount={state.sellAmount}
                currency={state.sellCurrency}
                currencies={currence}
                onAmountChange={onSellChange}
                onCurrencyChange={onSellCurrencyChange}
            />

            <ChangeCourses onSwitch={handleSwitch} arrangeSquare={arrangeSquare} />

            <RightInput
                amount={state.buyAmount}
                currency={state.buyCurrency}
                currencies={currence}
                onAmountChange={onBuyChange}
                onCurrencyChange={onBuyCurrencyChange}
            />
        </Grid>
    );
}
